import {Injectable} from '@angular/core';
import {StageService} from './stage.service';
import {ComponentBase} from '../component-base';
import {DeckHeightService} from './deck-height.service';
import {DragFloorEdge} from './drag-floor-edge.service';

declare let THREE: any;

@Injectable()
export class ShadowCasterController extends ComponentBase {

  private boundingBox;
  private mainFloor;
  private center;
  private size;
  private shadowCaster;
  private objectsToMonitor = ['stairs', 'floor', 'wall'];

  constructor(
    stage: StageService,
    deskHeightSrvc: DeckHeightService,
    dragFloorEdge: DragFloorEdge
  ) {
    super();
    this.boundingBox = new THREE.Box3();
    this.center = new THREE.Vector3();
    this.size = new THREE.Vector3();
    this.mainFloor = stage.getCompoundFloor();
    this.shadowCaster = stage.getObjectByName('shadowCaster');
    stage.objectAdded.subscribe(this.objectAdded);
    stage.objectRemoved.subscribe(this.objectRemoved);
    deskHeightSrvc.deckHeightChanged.subscribe(this.update);
    dragFloorEdge.tierResized.subscribe(this.update);
  }

  private objectAdded = (obj) => {
/*    if (this.objectsToMonitor.indexOf(obj.name) !== -1) {
      this.updateShadowCaster(this.mainFloor.children.length === 0 ? obj : this.mainFloor);
    }*/
  };

  private objectRemoved = (obj) => {
 /*   if (this.objectsToMonitor.indexOf(obj.name) !== -1) {
      this.updateShadowCaster(this.mainFloor);
    }*/
  };

  private update = () => {}; // this.updateShadowCaster(this.mainFloor);

  private updateShadowCaster(floor) {
    this.boundingBox.setFromObject(floor);
    this.boundingBox.getSize(this.size);
    this.boundingBox.getCenter(this.center);
    const longestSide = Math.max(this.size.x, this.size.z);
    const shadowCaster = this.shadowCaster;
    const shadowCamera = shadowCaster.shadow.camera;
    shadowCaster.position.set(
      (this.center.x + this.size.x / 2) * 1.5,
      this.size.y + 400,
      (this.center.z + this.size.z / 2) * 1.5
    );
    shadowCaster.target.position.set(
      (this.center.x - this.size.x / 2) * 1.5,
      10,
      (this.center.z - this.size.z / 2) * 1.5
    );
    shadowCamera.left = -longestSide;
    shadowCamera.right = longestSide;
    shadowCamera.bottom = -longestSide;
    shadowCamera.top = longestSide;
    shadowCamera.far = shadowCaster.position.distanceTo(shadowCaster.target.position) * 1.5;
    shadowCamera.updateProjectionMatrix();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/shadow-caster-controller.service.ts